import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GiftcardsRoutingModule } from './giftcards-routing.module';
import { GiftcardsComponent } from './giftcards.component';
import { GiftcardCreateModule } from './giftcard-create/giftcard-create.module';
import { GiftcardListModule } from './giftcard-list/giftcard-list.module';
import { GiftcardDetailsModule } from './giftcard-details/giftcard-details.module';
import { GiftcardCreateReturnModule } from './giftcard-create-return/giftcard-create-return.module';


@NgModule({
  declarations: [
    GiftcardsComponent
  ],
  imports: [
    CommonModule,
    GiftcardsRoutingModule,
    GiftcardCreateModule,
    GiftcardListModule,
    GiftcardDetailsModule,
    GiftcardCreateReturnModule
  ]
})
export class GiftcardsModule { }
